var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgError = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 17,
  height: 16,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M8.5 1.334a6.67 6.67 0 0 0-6.667 6.667A6.67 6.67 0 0 0 8.5 14.667a6.67 6.67 0 0 0 6.667-6.666A6.67 6.67 0 0 0 8.5 1.334m.667 10H7.833v-1.333h1.334zm0-2.667H7.833v-4h1.334z"
})));
export { SvgError as ReactComponent };
export default "/_next/static/images/error.svg";